import { computed, signal } from "@preact/signals-react"

const USER_DATA_KEY = 'rentacar_user_data'
const NEXT_CHECK_KEY = 'rentacar_next_check'

// Función para obtener datos del localStorage
const getInitialUserData = () => {
	try {
		const savedUserData = localStorage.getItem(USER_DATA_KEY)
		return savedUserData ? JSON.parse(savedUserData) : {}
	} catch (error) {
		console.error('Error parsing user data from localStorage:', error)
		localStorage.removeItem(USER_DATA_KEY)
		return {}
	}
}

const getInitialNextCheck = () => {
	try {
		const savedNextCheck = localStorage.getItem(NEXT_CHECK_KEY)
		return savedNextCheck ? JSON.parse(savedNextCheck) : null
	} catch (error) {
		console.error('Error parsing nextCheck from localStorage:', error)
		localStorage.removeItem(NEXT_CHECK_KEY)
		return null
	}
}

export const nextCheck = signal(getInitialNextCheck())
export const userData = signal(getInitialUserData())


// Computed
export const isUserMaster = computed(() => userData.value.isMaster)
export const slaveId = computed(() => userData.value.uidSlave)
export const isNewLogin = computed(() => userData.value.newUserLogin)
export const username = computed(() => userData.value.username)